<div class="form-group" attr.aria-describedby="{{ id }}-help">
  <div
    *ngIf="header_text"
    class="header-text normalize-external-styles"
    [innerHTML]="header_text | domSanitizer"
  ></div>

  <label
    *ngIf="label"
    for="{{ id }}-{{ name }}"
    class="form-label"
    [ngClass]="{ required: required }"
  >
    {{ label }}
  </label>

  <div class="input-group">
    <input
      ngbDatepicker
      id="{{ id }}-{{ name }}"
      class="form-control"
      placeholder="MM/DD/YYYY"
      maxlength="10"
      restrict-input="date"
      #d="ngbDatepicker"
      [class.is-invalid]="control.errors && control.dirty"
      [name]="name"
      [formControl]="control"
      [required]="required"
      [minDate]="min_date"
      [maxDate]="max_date"
    />
    <button as-button class="btn form-element-btn z-0" (click)="d.toggle()" type="button">
      <span class="material-icons"> calendar_month </span>
    </button>
  </div>

  <div *ngIf="control.dirty && control.errors" id="{{ id }}-error" class="text-danger mt-2">
    <span *ngIf="control.errors['required']">{{ 'input_is_required' | translate : label }}</span>
    <span *ngIf="control.errors['ngbDate']?.['invalid']">
      {{ ('invalid_input' | translate : label) + '.' }}
    </span>
    <span *ngIf="control.errors['ngbDate']?.['minDate'] && errors['min_date']">
      {{ errors['min_date'] }}.
    </span>
    <span *ngIf="!control.errors['ngbDate']?.['invalid'] && control.errors['pattern']">
      {{ 'invalid_date_format_input' | translate : 'MM/DD/YYYY' }}
    </span>
    <span *ngIf="control.errors['_error']">
      <ul class="m-0 p-0 list-unstyled">
        <li *ngFor="let error of control.errors['_error']" class="fw-light">{{ error }}</li>
      </ul>
    </span>
  </div>

  <div *ngIf="help_text" id="{{ id }}-help" class="form-text">
    {{ help_text }}
  </div>
</div>
